<template>
  <div v-if="!store.state.isWorkflowDisabled" class="d-flex" @click.stop>
    <v-tooltip location="bottom">
      <template v-slot:activator="{ props }">
        <v-icon v-bind="props" size="16" color="grey" class="cursor-pointer" @click="openDialog = true">
          mdi-pencil
        </v-icon>
      </template>
      Edit domain event
    </v-tooltip>
    <edit-domain-event-dialog
      :schema="schema"
      :modelValue="openDialog"
      @update:modelValue="(val) => openDialog = val"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useStore } from 'vuex'
import EditDomainEventDialog from '@/components/EditDomainEventDialog.vue'

defineProps({ schema: Object })

const store = useStore()
const openDialog = ref(false)
</script>
